import { Status } from './gallery';

class Autoplay {
    /**
     * Construct Autoplay logic.
     */
    constructor(gallery, intersectionObserverOptions = {}) {
        this.gallery = gallery;
        this.isVisible = false;
        this.shouldResume = false;

        const opt = intersectionObserverOptions;
        this.handleIntersect = this.handleIntersect.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

        if (Autoplay.hasIntersectionObserver()) {
            this.observer = new IntersectionObserver(this.handleIntersect, {
                root: opt.root || null,
                rootMargin: opt.rootMargin || '0px',
                threshold: opt.threshold || 1.0,
            });
        }
        else {
            // limited autoplay support, only play/pause based on tab visibility.
            const observe = () => {};
            this.observer = { observe };
            this.isVisible = true;
        }
    }

    /**
     * Start observing gallery.
     */
    start() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
        this.observer.observe(this.gallery.dom.element);
    }

    /**
     * Check browser support for IntersectionObserver.
     * @return {bool}
     */
    static hasIntersectionObserver() {
        return (('IntersectionObserver' in window) &&
            ('IntersectionObserverEntry' in window) &&
            ('intersectionRatio' in window.IntersectionObserverEntry.prototype));
    }

    /**
     * Pause gallery when it's out of viewport, resume when it's in viewport.
     * @private
     * @param {IntersectionObserverEntry[]} entries
     */
    handleIntersect(entries/* , observer */) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.isVisible = true;
                this.gallery.play();
            }
            else {
                this.isVisible = false;
                this.gallery.pause();
            }
        });
    }

    /**
     * Pause gallery when browser's tab lost visibility, resume when it's visible again.
     * @private
     */
    handleVisibilityChange() {
        if (document.hidden) {
            this.shouldResume = this.gallery.state.status === Status.Playing;
            this.gallery.pause();
        }
        else if (this.isVisible && this.shouldResume) {
            this.gallery.play();
        }
    }
}

export default Autoplay;
